/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import headerStyle from '../../../containers/ComponentConfigurations/ComponentConfigurations.module.css';
import ComponentConfigurationHelpButton from '../../../containers/ComponentConfigurations/ComponentConfigurationsHelpButton';
import Button from '../../@base/Button';
import ContextMenu from '../../ContextMenu/ContextMenu';
import DialogNotification from '../../DialogNotification/DialogNotification';
import Checkbox from '../../@base/Checkbox';
import { CHANNEL_FROM_WATSON } from '../../../dto/DialogDTO';

const ComponentConfigurationExtraConfigButton = (props) => {
  const options = [];

  if (!props.nextStepEnabled) {
    options.push({ label: 'Habilitar "Seguir para"', function: props.enableDisableNextStep });
  } else {
    options.push({ label: 'Desabilitar "Seguir para"', function: props.enableDisableNextStep });
  }

  if (!props.slotsEnabled) {
    options.push({ label: 'Habilitar "Coleta de informações do usuário"', function: props.enableDisableSlots });
  } else {
    options.push({ label: 'Desabilitar "Coleta de informações do usuário"', function: props.enableDisableSlots });
  }

  return (
    <ContextMenu
      classes={headerStyle.ExtraConfig}
      button={(
        <Button small title="Configurações extras" circle>
          <i className="fa fa-cog" aria-hidden="true" />
        </Button>
      )}
      options={
        options.map((o) => (
          <a
            role="button"
            tabIndex={0}
            onKeyPress={o.function}
            onClick={o.function}
            keyCode={o.label}
          >
            {o.label}
          </a>
        ))
      }
    />
  );
};

const ComponentConfigurationChannelConfigButton = (props) => {
  let enabledChannels = [...props.channelsEnabled];

  const enableDisableChannel = (channel) => {
    const enabled = enabledChannels.includes(channel);
    if (enabled) {
      enabledChannels = [...enabledChannels.filter((c) => c !== channel)];
    } else {
      enabledChannels = [...enabledChannels, channel];
    }
  };

  const options = Object.values(CHANNEL_FROM_WATSON).map((channel) => ({
    label: channel,
    enabled: props.channelsEnabled.includes(channel),
    function: () => enableDisableChannel(channel),
  }));

  return (
    <ContextMenu
      closeWhenClicked
      clickOut={() => props.saveEnabledChannels(enabledChannels)}
      classes={headerStyle.ChannelConfig}
      button={(
        <Button small title="Canais de comunicação que respondem esse nó" circle>
          <i className="fa fa-podcast" aria-hidden="true" />
        </Button>
      )}
      options={
        options.map((o) => (
          <a
            role="button"
            tabIndex={0}
          >
            <Checkbox
              onClick={o.function}
              checked={o.enabled}
              label={o.label}
              small
            />
          </a>
        ))
      }
    />
  );
};

export const DialogBreadCrumbs = (props) => {
  const [state, setState] = useState({ showHelperDialog: false });

  /** Mostra uma caixa de dialogo que explica como funciona o componente */
  const showHelperDialogComponent = () => {
    if (state.showHelperDialog) {
      const content = (
        <div className={headerStyle.Helper}>
          <p>
            O fluxo de diálogo define a conversa na forma de uma árvore lógica.
            Cada nó de diálogo corresponde intenções (o que os usuários dizem) a respostas
            (o que o seu assistente virtual responde).
            O nó também pode ter uma condição que o aciona, com base na entrada do usuário.
          </p>
          <p>
            Nós do diálogo podem ser pastas, nesse caso usadas
            apenas para melhorar a organização do fluxo.
          </p>
        </div>
      );
      return (
        <DialogNotification
          color="info"
          title={<p>Como funciona esse componente?</p>}
          content={content}
          okAction={() => setState({ showHelperDialog: false })}
        />
      );
    }
  };

  return (
    <>
      {showHelperDialogComponent()}
      <div className={headerStyle.Header}>
        <div className={headerStyle.HeaderTop}>
          <span className={headerStyle.BreadCrumb}>
            Componentes/
            {props.watsonNameInstance}
            /
            {props.selectedDialog.data.label}
          </span>
          <div
            title="Esse nó não responde todos os canais"
            className={`${headerStyle.ChannelTag} ${props.channelsEnabled.join(',') === CHANNEL_FROM_WATSON.web ? headerStyle.TagWeb : ''}`}
            style={{
              visibility:
                props.channelsEnabled.length === Object.values(CHANNEL_FROM_WATSON).length
                  ? 'hidden'
                  : 'visible',
            }}
          >
            <smal>
              {'Responde apenas: '}
              {props.channelsEnabled.join(',')}
            </smal>
          </div>
        </div>

        <div className={headerStyle.Title}>
          <input
            value={props.title}
            onChange={(e) => props.setTitle(e.target.value)}
            type="text"
            onBlur={() => props.save()}
            placeholder={props.selectedDialog.data.untitlePlaceholder}
          />
        </div>

        <div style={{ display: 'inline-block', width: '30%' }}>
          <ComponentConfigurationHelpButton setState={setState} />
          <ComponentConfigurationExtraConfigButton
            nextStepEnabled={props.nextStepEnabled}
            enableDisableNextStep={props.enableDisableNextStep}
            slotsEnabled={props.slotsEnabled}
            enableDisableSlots={props.enableDisableSlots}
          />
          <ComponentConfigurationChannelConfigButton
            channelsEnabled={props.channelsEnabled}
            setChannelsEnabled={props.setChannelsEnabled}
            saveEnabledChannels={props.saveEnabledChannels}
          />
          <Button
            circle
            small
            title="Apagar pasta/diálogo"
            onClick={() => props.setDialogToDelete([props.selectedDialog])}
          >
            <i className="fa fa-trash" aria-hidden="true" />
          </Button>

        </div>
      </div>
    </>
  );
};

export default DialogBreadCrumbs;
